import React, {Component} from "react";
import {Table, Thead, Tbody, Tr, Th, Td} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import moment from "moment";
import {Button} from "antd";
import dayjs from "dayjs";
import { formatMoney } from "helpers/currency";
import { serviceLabel, paymentStatusLabel, tagLabel, roleLabel, bookingStateLabel } from "helpers/adminLabels";

class BookingList extends Component {
  tableRowElement(bookings) {
    if (bookings) {
      return bookings?.map((booking) => {
        booking.refund = {
          price: 0,
          reason: '',
          description: '',
          id: booking?._id,
          stripePaymentID: booking?.stripePaymentID,
          currentPrice: booking?.price
        }

      const hide_refund = this.props?.search?.searchInArchive === true ? 0:1; //swap values


        return (
          <Tr key={booking._id}>
            <Td>{booking?.parentID?.name} {booking?.parentID?.surname}</Td>
            <Td>{serviceLabel(booking.description)}</Td>
            <Td>{tagLabel(booking.status)} / {tagLabel(booking.meetingType)}</Td>
            <Td>{paymentStatusLabel(booking.paymentStatus)}</Td>
            <Td>{bookingStateLabel(booking?.invoicing[0]?.bookingState)} <br/>
                Такса: {formatMoney(booking?.invoicing[0]?.hpnAmount, { locale: "bg" })}
                {booking?.invoicing[0]?.hpnInvoiceNumber>0 && (
                  <React.Fragment>
                    <br/>
                    Фактура: <b>{booking?.invoicing[0].hpnInvoiceNumber}</b><br/>
                    {dayjs(booking?.invoicing[0].hpnInvoiceDate).format('DD.MM.YYYY')}
                  </React.Fragment>
                ) }

              </Td>
            <Td>
              <br/> Платено на специалиста: <br/>
                <b>
                  {booking.invoicing[0]?.hpnPaid && (
                    <React.Fragment>
                      Да <br/>
                      {dayjs(booking.invoicing[0].hpnPaidDate).format('DD.MM.YYYY')}
                    </React.Fragment>
                  )}
                  {!booking.invoicing[0]?.hpnPaid && ('N/A')}
                </b>
              </Td>
            <Td className='text-center'>

              { booking.paymentStatus === 'succeeded'
                && booking.transactions.reduce((partialSum, refund) => partialSum + refund.price, 0) < Number(booking.price)
                && hide_refund
                ?
                <Button onClick={() => {
                  this.props.onRefundOpen(booking)
                  this.props.setRefundModalOpen(true)
                }}>Възстанови</Button> : '-'
              }
            </Td>
            <Td>{!isNaN(Number(booking.price)) ? formatMoney(booking.price, { locale: "bg" }) : '-'}
              {booking.transactions.length > 0 &&
                <div
                  className="text-danger">Възстановено: {formatMoney(booking.transactions.reduce((partialSum, refund) => partialSum + refund.price, 0), { locale: "bg" })}</div>}
            </Td>
            <Td>{roleLabel(booking.professionalID?.role)}: {booking.professionalID?.name} {booking.professionalID?.surname}</Td>
            <Td>
              {moment(booking?.time).format("DD MMM YYYY")} {moment(booking.time).format("HH:mm")}
            </Td>
            <Td>
              {moment(booking?.createdAt).format('DD MMM YYYY')}
            </Td>
          </Tr>
        );
      })
    }
  }

  render() {
    const {list} = this.props
    return (
      <div className="table-rep-plugin">
        <div className="table-responsive mb-0" data-pattern="priority-columns">
          <Table
            id="tech-companies-1"
            className="table table-striped table-bordered"
          >
            <Thead>
              <Tr>
                <Th data-priority="1">Стопанин</Th>
                <Th data-priority="3">Услуга</Th>
                <Th data-priority="3">Статус</Th>
                <Th data-priority="1">Статус на плащане</Th>
                <Th data-priority="1">Статус на часа</Th>
                <Th data-priority="3">Данни за контрагент</Th>
                <Th data-priority="3">Възстановяване</Th>
                <Th data-priority="3">Цена</Th>
                <Th data-priority="1">Специалист</Th>
                <Th data-priority="3">Дата на часа</Th>
                <Th data-priority="3">Създадена на</Th>
              </Tr>
            </Thead>
            <Tbody>{this.tableRowElement(list)}</Tbody>
          </Table>
        </div>

      </div>
    );
  }
}

export default BookingList;
